module.exports = __webpack_public_path__ + "static/student-sandbox-bg-md-e9a5a5f7928588646925d2274b922758.jpg";